import { ChevronLeft, ChevronRight } from "react-feather";
import { Href } from "../../../../../../Constants/Constants";
import { useAppDispatch } from "../../../../../../ReduxToolkit/Hooks";
import { setSettingsActiveTab } from "../../../../../../ReduxToolkit/Reducers/Messenger/MainSidebar";
import { CommonMediaHeadingType } from "../../../../../../Types/MessengerType";

const CommonMediaHeading: React.FC<CommonMediaHeadingType> = ({ title, text, type }) => {
  const dispatch = useAppDispatch();
  return (
    <div className={`d-flex ${!type && "align-items-center"}`}>
      <div className="flex-grow-1">
        <h3>{title}</h3>
        <h5 className="mt-1">{text}</h5>
      </div>
      <div className="media-right">
        <a className={`icon-btn btn-outline-light btn-sm pull-right ${type ? "next" : "previous"}`} href={Href} onClick={() => dispatch(setSettingsActiveTab(type))}>
          {type ? <ChevronRight /> : <ChevronLeft />}
        </a>
      </div>
    </div>
  );
};

export default CommonMediaHeading;
